var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("input", {
    directives: [
      {
        name: "model",
        rawName: "v-model",
        value: _vm.checkedModels,
        expression: "checkedModels",
      },
    ],
    staticClass: "form-check-input",
    attrs: { type: "checkbox", disabled: _vm.loading, id: _vm.model.id },
    domProps: {
      value: _vm.model,
      checked: Array.isArray(_vm.checkedModels)
        ? _vm._i(_vm.checkedModels, _vm.model) > -1
        : _vm.checkedModels,
    },
    on: {
      click: _vm.check,
      change: function ($event) {
        var $$a = _vm.checkedModels,
          $$el = $event.target,
          $$c = $$el.checked ? true : false
        if (Array.isArray($$a)) {
          var $$v = _vm.model,
            $$i = _vm._i($$a, $$v)
          if ($$el.checked) {
            $$i < 0 && (_vm.checkedModels = $$a.concat([$$v]))
          } else {
            $$i > -1 &&
              (_vm.checkedModels = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkedModels = $$c
        }
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }